import { render, staticRenderFns } from "./NoticeManagementDetail.vue?vue&type=template&id=31b2390e&scoped=true"
import script from "./NoticeManagementDetail.vue?vue&type=script&lang=js"
export * from "./NoticeManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./NoticeManagementDetail.vue?vue&type=style&index=0&id=31b2390e&prod&scoped=true&lang=scss"
import style1 from "./NoticeManagementDetail.vue?vue&type=style&index=1&id=31b2390e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2390e",
  null
  
)

export default component.exports